export const runAfterInitialLoad = (callback: () => void, fallbackDelay = 4000) => {
	const windowWithIdle = window as Window & {
		requestIdleCallback?: (cb: () => void, options?: { timeout?: number }) => number;
		cancelIdleCallback?: (handle: number) => void;
	};

	if (windowWithIdle.requestIdleCallback) {
		const idleId = windowWithIdle.requestIdleCallback(callback, { timeout: fallbackDelay });
		return () => windowWithIdle.cancelIdleCallback?.(idleId);
	}

	const timeoutId = window.setTimeout(callback, fallbackDelay);
	return () => window.clearTimeout(timeoutId);
};
